module.exports = __webpack_public_path__ + "static/media/1024573.07b3f5c4.jpg";